import type { MultiValueColorScheme } from "@src/components/ui-kit/budget-path-select/types";
import type { ChakraStylesConfig, GroupBase } from "chakra-react-select";

export const DEFAULT_MULTI_VALUE_COLOR_SCHEME: MultiValueColorScheme = {
  backgroundColor: "grey.100",
  textColor: "inherit",
  borderColor: "transparent",
  removeHoverBackgroundColor: "grey.200",
};

export const MULTI_VALUE_COLOR_SCHEMES: MultiValueColorScheme[] = [
  {
    backgroundColor: "blue.100",
    textColor: "blue.800",
    borderColor: "blue.300",
    removeHoverBackgroundColor: "blue.200",
  },
  {
    backgroundColor: "green.100",
    textColor: "green.800",
    borderColor: "green.300",
    removeHoverBackgroundColor: "green.200",
  },
  {
    backgroundColor: "orange.100",
    textColor: "orange.800",
    borderColor: "orange.300",
    removeHoverBackgroundColor: "orange.200",
  },
];

/**
 * Paths are Brand, Project, Budget Item
 * We can't show divider (arrow) after Budget Item because it's the last path
 */
export const MAX_POSSIBLE_DIVIDER_INDEX = 1;

export const BUDGET_PATH_SELECT_CHAKRA_STYLES: ChakraStylesConfig<
  unknown,
  boolean,
  GroupBase<unknown>
> = {
  control: (provided) => ({
    ...provided,
    minW: 0,
    overflow: "hidden",
  }),
  valueContainer: (provided) => ({
    ...provided,
    flexWrap: "nowrap",
    overflow: "hidden",
    minW: 0,
  }),
  multiValue: (provided) => ({
    ...provided,
    minW: "max-content",
    maxW: "100%",
    flexShrink: 1,
    mr: 0,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minW: 0,
  }),
};
